import {RootState, AppThunk} from '../../app/store';
import { resetUser, setAuth} from "../../core/reducer/auth/authSlice";




export const logoutAction =
    (): AppThunk =>
        (dispatch) => {
            localStorage.removeItem('token');
            dispatch(setAuth(false));
            dispatch(resetUser());
        };
